import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DashboardHoldingSummaryUseCase extends BaseUseCase {
    constructor(dashboardRepo) {
        super();
        this.dashboardRepo = dashboardRepo;
    }
    async fetchResult(req) {
        return await this.dashboardRepo.getHoldingDashboard(req);
    }
}
export default DashboardHoldingSummaryUseCase;
